import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { ShowPortfolioPicsModal } from './Modal_ShowPortfolioPics';
import { ViewPortfolioDetailDataModal } from './/Modal_ViewPortfolioDetails';
import { AddPortfolioModal } from './Modal_AddPortfolio';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';



 export function Tab_Management_Portfolio () {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);

    let [addPortfolioModal, setAddPortfolioModal] = useState(false);
    let [modifyPortfolioModal, setModifyPortfolioModal] = useState(false);
    let [viewInventoryPortfolioMainDetailsData_online, setViewInventoryPortfolioMainDetailsData_online] = useState([]);
    let [viewInventoryPortfolioMainDetailsData_onsite, setViewInventoryPortfolioMainDetailsData_onsite] = useState([]);

    let [viewPortfolioDetailsData, setViewPortfolioDetailsData] = useState([]);
    let [showPortfolioDetails, setShowPortfolioDetails] = useState(false);


    let [deleteInventoryPortfolioModal, setDeleteInventoryPortfolioModal] = useState(false);
    let [adminPasswordCreateInventoryPortfolioModal, setAdminPasswordCreateInventoryPortfolioModal] = useState(false);

    let [activatePortfolioButton, setActivatePortfolioButton] = useState('inline-block');
    let [deactivatePortfolioButton, setDeactivatePortfolioButton] = useState('inline-block');

    let [showPortfolioPics, setShowPortfolioPics] = useState(false);
    let [itemID, setItemID] = useState(null);
    let [portfolioID, setPortfolioID] = useState(null);
    let [portfolioSalePrice, setPortfolioSalePrice] = useState(null);
    let [portfolioDateCreated, setPortfolioDateCreated] = useState(null);
    let [portfolioPic1, setPortfolioPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [portfolioPic2, setPortfolioPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [portfolioPic3, setPortfolioPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [portfolioPic4, setPortfolioPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [portfolioPicsModal, setPortfolioPicsModal] = useState(false);

    let [discountOfList, setDiscountOfList] = useState(null);
    let [salePrice, setSalePrice] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);

    let [searchResults, setSearchResults] = useState([]);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let salePriceRef = useRef('');
    let discountOfListRef = useRef('');
    let itemIDRef = useRef('');
    let portfolioIDRef = useRef('');
    let portfolioNameRef = useRef('');
    let portfolioItemNameRef = useRef('');






    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        if(searchCategory === 'stock_portfolio')
        {

            Tracker = '74302_stock_portfolio';
        }
        else if(searchCategory === 'delete_stock_portfolio')
        {

            Tracker = '74304_delete_stock_portfolio';

        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '72302_search_inventory_items',
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_portfolioId: cols[0],
                                        db_portfolioName: cols[1],
                                        db_portfolioDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });

                            }

                    })
        }

    function getPortfolioListData() {
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74301_portfolioList',
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewInventoryPortfolioMainDetailsData_online((prevViewInventoryPortfolioMainDetailsData) => {
                    return prevViewInventoryPortfolioMainDetailsData.concat({
                        projectID: cols[0],
                        portfolioID: cols[1],
                        portfolioName: cols[2],
                        portfolioDescription: cols[3],
                        clientName: cols[4],
                        clientFeedback: cols[5],
                        createdAt: cols[6],
                        portfolioStatus: cols[7],
                    })
                });

            } 
        })
        
}

function activationStatus(event) {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74309_activation_portfolio',
            user: acctID,
            xPortfolioID: event[1],
            xPortfolioActivationStatus: event[0],
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);
    })

    setShowPortfolioPics(false);
    setViewPortfolioDetailsData([]);
    setViewPortfolioDetailsData([]);
}

function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}



function saveUploadedFile(event) {
    
    alert(event);
    
    if(event.target.files == null)
    {
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")
    }
    else
    {
        setSelectedFile(event.target.files[0])

    }


}

let timeout;

function handleInput(event) {


    document.getElementById('searchInventoryPortfolio_StockPortfolioItemsList').innerHTML = '';


    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

function portfolioDetailsHandler(event)
{
    //alert("in portfolio details handler");
    //alert(event[1]);


    setPortfolioID(event[1]);
    setShowPortfolioDetails(event[0]);
}



useEffect(() =>  {
        
    getPortfolioListData(); 

}, [])


        return (
            <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol>
                            <h3> Portfolio List</h3>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
                        <div style={{display: 'inline-block'}}>               

                        <IonGrid >
                            <IonRow >
                                    <IonCol >Portfolio ID</IonCol>
                                    <IonCol >Portfolio Name</IonCol>
                                    <IonCol >Selling Price</IonCol>
                                    <IonCol >Margin</IonCol>
                                    <IonCol >Action</IonCol>
                            </IonRow>
                            {viewInventoryPortfolioMainDetailsData_online.map((detailData) =>   {
                                return (
                                    <IonRow class='gridResultBody'>
                                        <IonCol >{detailData.portfolioID}</IonCol>
                                        <IonCol >{detailData.portfolioName}</IonCol>
                                        <IonCol >{detailData.portfolioSalePrice}</IonCol>
                                        <IonCol >{detailData.margin}</IonCol>
                                        <IonCol >
                                            {detailData.portfolioStatus == 'INACTIVE' && <IonButton  style={{display: activatePortfolioButton}} onClick={() => activationStatus(["yes", detailData.portfolioID])}> ACTIVATE </IonButton>}
                                            {detailData.portfolioStatus == 'ACTIVE' && <IonButton style={{display: deactivatePortfolioButton}} onClick={() => activationStatus(["no", detailData.portfolioID])}> DEACTIVATE </IonButton> }
                                            <IonButton onClick={() => portfolioDetailsHandler([true, detailData.portfolioID])}>Details </IonButton>
                                        </IonCol>
                                    </IonRow>
                                )
                            }
                            )}

                        <IonRow >
                            <IonCol size="12">
                                {(authenticatedMerchent_context.initialSetup?.details?.step_1 == true && authenticatedMerchent_context.initialSetup?.details?.step_2 == false) ?
                                <IonButton className='flash-tutorial'  onClick={() => setAddPortfolioModal(true)}>Add Portfolio</IonButton>
                                : <IonButton  onClick={() => setAddPortfolioModal(true)}>Add Portfolio</IonButton>
                                }
                            </IonCol>
                        </IonRow>
                        </IonGrid>
                        </div>

                        {portfolioPicsModal == true &&  <ShowPortfolioPicsModal openModal={ portfolioPicsModal } closeModal={() => setPortfolioPicsModal(false)} data={{
                    portfolioPic1: portfolioPic1, 
                    portfolioPic2: portfolioPic2, 
                    portfolioPic3: portfolioPic3, 
                    portfolioPic4: portfolioPic4, 
                    portfolioID: portfolioID, 
                    portfolioSalePrice: portfolioSalePrice
                    }}>
                </ShowPortfolioPicsModal>}

            

                {showPortfolioDetails == true &&  <ViewPortfolioDetailDataModal openModal={ showPortfolioDetails } closeModal={() => setShowPortfolioDetails(false)} data={{
                    portfolioID: portfolioID, 
                    portfolioSalePrice: portfolioSalePrice
                    }}>
                </ViewPortfolioDetailDataModal>}

                {addPortfolioModal == true &&  <AddPortfolioModal openModal={ addPortfolioModal } closeModal={() => setAddPortfolioModal(false)}>
                </AddPortfolioModal>}

                </IonContent>

        </React.Fragment>

        )
    }   



export default Tab_Management_Portfolio;